'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeEquipmentStorage = {
    fromJson: fromJson,
    getEquipmentStorage: getEquipmentStorage,
};

function fromJson(data) {
    var reqProps = ['$id'];
    return FirebaseObject.$fromJson(data, 'EquipmentStorage', reqProps, reqProps,
        function(data) { return getEquipmentStorage(data.$id); }
    );
}

function getEquipmentStorage(equipmentId) {
    var key = 'EquipmentStorage: ' + equipmentId;
    var equipmentStorage = KayleeCache.get(key);

    if (equipmentStorage === null) {
        equipmentStorage = new EquipmentStorage(equipmentId);
        KayleeCache.put(key, equipmentStorage);
    }

    return equipmentStorage;
}

function EquipmentStorage(equipmentId) {
    this.$nodeType = 'equipmentStorage';
    FirebaseObject.call(this, KayleeBase.app.database().ref('equipmentStorage/' + equipmentId));
}

EquipmentStorage.prototype = Object.create(FirebaseObject.prototype);
EquipmentStorage.prototype.constructor = EquipmentStorage;

EquipmentStorage.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ]);
};

EquipmentStorage.prototype.toString = function() {
    return '[EquipmentStorage (' + this.$id + ')]';
};



module.exports = KayleeEquipmentStorage;
